import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EducationalQualification  {
    _originalTypeClassName = "zERP.BO.EducationalQualification";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EducationalQualification.translate = translateService;
}
this.Id = null;
this.TitleName = null;
this.Duration = null;
this.GraduationDate = null;
this.acknowledged = false;
this.Code_ = null;
this.DocumentType = null;
this.DocumentDescription = null;
this.DocumentPath = null;
this.AcquisitionYear = null;
this.State = null;
this.HRComment = null;
this.EmpComment = null;
this.StatePrevious = null;
this.HRState = null;
this.IsHRAdd = false;
this.GraduationYear = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TitleName:any;
Duration:any;
GraduationDate:any;
acknowledged:any;
Code_:any;
DocumentType:any;
DocumentDescription:any;
DocumentPath:any;
AcquisitionYear:any;
State:any;
HRComment:any;
EmpComment:any;
StatePrevious:any;
HRState:any;
IsHRAdd:any;
GraduationYear:any;
InstitutionName:any;
Employee:any;
Diploma:any;
EducationalDirection:any;
StudiesField:any;
Level:any;
static setInstitutionName = ($this, value) => {
var oldValue = $this.InstitutionName;
$this.InstitutionName = value;
if (value != null) {
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
if (oldValue != null) {
Domain.Employee.removeEducationalQualifications(oldValue, $this);
}
Domain.Employee.addEducationalQualifications(value, $this);
}
}
static setDiploma = ($this, value) => {
var oldValue = $this.Diploma;
$this.Diploma = value;
if (value != null) {
}
}
static setEducationalDirection = ($this, value) => {
var oldValue = $this.EducationalDirection;
$this.EducationalDirection = value;
if (value != null) {
}
}
static setStudiesField = ($this, value) => {
var oldValue = $this.StudiesField;
$this.StudiesField = value;
if (value != null) {
}
}
static setLevel = ($this, value) => {
var oldValue = $this.Level;
$this.Level = value;
if (value != null) {
}
}

static GetClassName(): any{return "EducationalQualification";
}
static ParseAcknowledged(el: any): any{return (!(CLMS.Framework.String.IsNullOrEmpty((el ?? '').trim())) && !(CLMS.Framework.String.IsNullOrEmpty(el)) && el == "ΝΑΙ" ? true : false);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}